import type { UiEvent } from '$lib/server/supabase';
import { writable } from 'svelte/store';
import { Attending } from './eventTypes';
import { addWeeks, startOfHour, setHours } from 'date-fns';

export const currentEvent = writable(defaultUiEvent());

export function isUserAttending(userId: string, event: UiEvent) {
	const guest = event.guests.find((x) => x.user.id === userId);
	return guest === undefined ? Attending.UNKNOWN : guest.attending;
}

function defaultUiEvent(): UiEvent {
	const defaultEvent = {
		id: '',
		name: '',
		createdAt: '',
		ownerSecret: '',
		slug: '',
		coverImageUrl: '',
		description: '',
		location: '',
		price: 0,
		beginAt: addWeeks(startOfHour(setHours(new Date(), 19)), 1).toISOString(),
		guests: [],
		bring: [],
		visitors: [],
		items: [],
		guestsInteracted: [],
		owners: [],
	} as UiEvent;
	for (const prop in defaultEvent) {
		const event = defaultEvent as Record<string, unknown>;
		event[prop] = undefined;

		// those fields need to be ommited so they can be generated by the DB
		if (['id', 'createdAt'].includes(prop)) {
			delete event[prop];
		}
	}
	return defaultEvent;
}
